// Multi-language configuration
export const translations = {
    zh: {
        title: 'Ibom Studio',
        selectTemplate: '选择项目模板',
        startFromScratch: '从头开始',
        createProject: '创建项目',
        templates: {
            empty: '空白项目',
            piano: '钢琴独奏',
            band: '乐团编曲',
            electronic: '电子音乐',
            hiphop: 'Hip-Hop节拍',
            acoustic: '民谣吉他'
        },
        templateDesc: {
            empty: '空白项目，自由创作',
            piano: '包含钢琴轨道的基础模板',
            band: '包含鼓组、贝斯、吉他的乐团模板',
            electronic: '电子音乐制作模板',
            hiphop: 'Hip-Hop节拍制作模板',
            acoustic: '民谣吉他录音模板'
        },
        file: '文件', edit: '编辑', new: '新建项目', save: '保存项目', export: '导出音频', import: '导入',
        undo: '撤销', redo: '重做', tracks: '轨道', addMidiTrack: '添加 MIDI 轨道', addAudioTrack: '添加音频轨道',
        mixer: '混音台', pianoRoll: '钢琴卷帘', play: '播放', stop: '停止', record: '录制', loop: '循环',
        metronome: '节拍器', quantize: '量化', automation: '自动化', volume: '音量', pan: '声像',
        mute: '静音', solo: '独奏', reverb: '混响', delay: '延迟', chorus: '合唱', eq: '均衡器',
        compressor: '压缩器', lowFreq: '低频', midFreq: '中频', highFreq: '高频', threshold: '阈值',
        ratio: '比率', attack: '起音', release: '释放', fadeIn: '淡入', fadeOut: '淡出',
        snap: '网格吸附', language: '语言', english: 'English', chinese: '中文',
        audioEngine: '音频引擎运行中', cpu: 'CPU', memory: '内存', sampleRate: '采样率', buffer: '缓冲区',
        atLeastOneTrack: '至少需要保留一个轨道', selectMidiTrack: '请先选择一个 MIDI 轨道',
        importSuccess: '成功导入文件', importFailed: '文件导入失败', exportingAudio: '正在导出音频...',
        exportComplete: '音频导出完成', recording: '录音中...', recordingStopped: '录音已停止',
        recordingFailed: '录音失败', exportFailed: '导出失败', stopRecordingFirst: '请先停止录音',
        dropAudioFiles: '拖放音频文件到轨道', supportedFormats: 'MP3, WAV, M4A, AAC, OGG, FLAC',
        pleaseDropAudioFiles: '请拖拽音频文件', audioProcessingFailed: '音频处理失败',
        fileProcessingFailed: '文件处理失败', close: '关闭', addNote: '添加音符', deleteNote: '删除音符',
        editNote: '编辑音符', velocity: '力度', pitch: '音高', duration: '时长', selectedClip: '已选择片段',
        clickToPlay: '点击时间轴任意位置开始播放', onlyMidiTracks: '钢琴卷帘仅适用于 MIDI 轨道',
        createMidiClip: '创建MIDI片段', clickKeyToAddNote: '点击钢琴键添加音符',
        drumPads: '鼓垫', bassKeys: '贝斯键盘', synthPads: '合成器垫',
        kick: '底鼓', snare: '军鼓', hihat: '踩镲', crash: '镲片', openhat: '开镲',
        audioEngineNotReady: '音频引擎未就绪',
        drumKit: '架子鼓',
        tom1: '高音筒', tom2: '中音筒鼓', tom3: '低音筒鼓',
        ride: '叮叮镲', splash: '溅音镲',
        // Track selection modal
        addNewTrack: '添加新轨道',
        voiceAndMic: '人声和麦克风',
        keys: '键盘',
        bassAnd808: '贝斯和808',
        guitar: '吉他',
        drumsAndMachines: '鼓组和鼓机',
        guitarBassAmp: '吉他/贝斯放大器',
        synth: '合成器',
        orchestral: '管弦乐',
        voiceMicDesc: '录制人声和麦克风输入',
        keysDesc: '钢琴、风琴和键盘乐器',
        bassDesc: '贝斯合成器和808鼓',
        guitarDesc: '电吉他和原声吉他',
        drumsDesc: '鼓组和鼓机',
        ampDesc: '放大的吉他和贝斯',
        synthDesc: '合成器和电子音色',
        orchestralDesc: '管弦乐和古典乐器',
        importFile: '导入文件',
        loopLibrary: '循环库',
        sampler: '采样器',
        loopLibraryComingSoon: '循环库即将推出！',
        samplerComingSoon: '采样器即将推出！',
        // Icon / control tooltips (native title on hover)
        ttEngineOn: '音频引擎已就绪',
        ttEngineOff: '音频引擎未就绪',
        ttLanguage: '界面语言',
        ttProjectName: '项目名称',
        ttNewProject: '新建项目（选择模板）',
        ttOpenProject: '打开项目（.ibom）',
        ttSaveProject: '保存项目为 .ibom 文件',
        ttExportWav: '导出混音为 WAV（从开头离线渲染整条时间线）',
        ttGoToStart: '回到开头（时间码归零）',
        ttPause: '暂停播放',
        ttStopTransport: '停止播放',
        ttRecord: '录音',
        ttTimeCode: '当前播放位置（小节:拍:细分）',
        ttBpm: '速度（每分钟拍数）',
        ttLoopActive: '循环已开启：在标尺选区内重复播放',
        ttLoopPrompt: '循环关闭：点击后在标尺选区内重复播放',
        ttLoopNoRegion: '请先在标尺上拖选循环区域',
        ttAutomationLanes: '显示轨道自动化轨道',
        ttMasterVolume: '主输出音量',
        ttZoom: '时间轴横向缩放（每拍像素）',
        ttGridDivision: '网格吸附与细分',
        ttSelectTool: '选择工具：移动、修剪片段',
        ttFadeTool: '淡化工具：在片段边缘拖出淡入/淡出',
        ttCloseMixer: '关闭混音台',
        ttMixerResize: '拖动调整混音台高度',
        ttPianoRollClose: '关闭钢琴卷帘',
        vocalPresets: '人声预设',
        vocalPresetHint: '应用到当前选中轨道的插入式效果链；之后仍可用旋钮自由调整。',
        vocalPresetClean: '干净人声',
        vocalPresetPop: '流行人声',
        vocalPresetRap: '说唱人声',
        vocalPresetWarm: '温暖人声',
        vocalPresetRadio: '电台声',
        lyrics: '歌词',
        lyricsRowHint: '点击空白处在此时间添加一行歌词',
        lyricsDragHint: '拖动以移动时间位置（输入框旁的手柄或空白处）',
        ttLyricsRow: '展开或收起时间轴歌词行',
        ttLyricsRowViewMode: '仅查看：只显示歌词文字',
        ttLyricsRowEditMode: '编辑：添加、拖动、删除歌词行',
    },
    en: {
        title: 'Ibom Studio',
        selectTemplate: 'Select Project Template',
        startFromScratch: 'Start from Scratch',
        createProject: 'Create Project',
        templates: {
            empty: 'Empty Project',
            piano: 'Piano Solo',
            band: 'Band Arrangement',
            electronic: 'Electronic Music',
            hiphop: 'Hip-Hop Beat',
            acoustic: 'Acoustic Guitar'
        },
        beats: 'beats',
        bars: 'bars',
        notes: 'notes',
        audio: 'Audio',
        audioPlaying: 'Audio playing',
        templateDesc: {
            empty: 'Empty project for free creation',
            piano: 'Basic template with piano track',
            band: 'Band template with drums, bass, guitar',
            electronic: 'Electronic music production template',
            hiphop: 'Hip-Hop beat making template',
            acoustic: 'Acoustic guitar recording template'
        },
        file: 'File', edit: 'Edit', new: 'New Project', save: 'Save Project', export: 'Export Audio', import: 'Import',
        undo: 'Undo', redo: 'Redo', tracks: 'Tracks', addMidiTrack: 'Add MIDI Track', addAudioTrack: 'Add Audio Track',
        mixer: 'Mixer', pianoRoll: 'Piano Roll', play: 'Play', stop: 'Stop', record: 'Record', loop: 'Loop',
        metronome: 'Metronome', quantize: 'Quantize', automation: 'Automation', volume: 'Volume', pan: 'Pan',
        mute: 'Mute', solo: 'Solo', reverb: 'Reverb', delay: 'Delay', chorus: 'Chorus', eq: 'Equalizer',
        compressor: 'Compressor', lowFreq: 'Low', midFreq: 'Mid', highFreq: 'High', threshold: 'Threshold',
        ratio: 'Ratio', attack: 'Attack', release: 'Release', fadeIn: 'Fade In', fadeOut: 'Fade Out',
        snap: 'Snap to Grid', language: 'Language', english: 'English', chinese: '中文',
        audioEngine: 'Audio Engine Running', cpu: 'CPU', memory: 'Memory', sampleRate: 'Sample Rate', buffer: 'Buffer',
        atLeastOneTrack: 'At least one track must be kept', selectMidiTrack: 'Please select a MIDI track first',
        importSuccess: 'File imported successfully', importFailed: 'File import failed', exportingAudio: 'Exporting audio...',
        exportComplete: 'Audio export complete', recording: 'Recording...', recordingStopped: 'Recording stopped',
        recordingFailed: 'Recording failed', exportFailed: 'Export failed', stopRecordingFirst: 'Please stop recording first',
        dropAudioFiles: 'Drop audio files on tracks', supportedFormats: 'MP3, WAV, M4A, AAC, OGG, FLAC',
        pleaseDropAudioFiles: 'Please drop audio files', audioProcessingFailed: 'Audio processing failed',
        fileProcessingFailed: 'File processing failed', close: 'Close', addNote: 'Add Note', deleteNote: 'Delete Note',
        editNote: 'Edit Note', velocity: 'Velocity', pitch: 'Pitch', duration: 'Duration', selectedClip: 'Selected Clip',
        clickToPlay: 'Click anywhere on timeline to start playback', onlyMidiTracks: 'Piano Roll only available for MIDI tracks',
        createMidiClip: 'Create MIDI Clip', clickKeyToAddNote: 'Click piano keys to add notes',
        drumPads: 'Drum Pads', bassKeys: 'Bass Keyboard', synthPads: 'Synth Pads',
        kick: 'Kick', snare: 'Snare', hihat: 'Hi-Hat', crash: 'Crash', openhat: 'Open Hat',
        audioEngineNotReady: 'Audio Engine Not Ready',
        drumKit: 'Drum Kit',
        tom1: 'High Tom', tom2: 'Mid Tom', tom3: 'Floor Tom',
        ride: 'Ride', splash: 'Splash',
        // Track selection modal
        addNewTrack: 'Add new track',
        voiceAndMic: 'Voice & Mic',
        keys: 'Keys',
        bassAnd808: 'Bass & 808',
        guitar: 'Guitar',
        drumsAndMachines: 'Drums & Machines',
        guitarBassAmp: 'Guitar/Bass Amp',
        synth: 'Synth',
        orchestral: 'Orchestral',
        voiceMicDesc: 'Record vocals and microphone input',
        keysDesc: 'Piano, organ, and keyboard instruments',
        bassDesc: 'Bass synthesizers and 808 drums',
        guitarDesc: 'Electric and acoustic guitar',
        drumsDesc: 'Drum kits and drum machines',
        ampDesc: 'Amplified guitar and bass',
        synthDesc: 'Synthesizers and electronic sounds',
        orchestralDesc: 'Orchestral and classical instruments',
        importFile: 'Import file',
        loopLibrary: 'Loop library',
        sampler: 'Sampler',
        loopLibraryComingSoon: 'Loop library coming soon!',
        samplerComingSoon: 'Sampler coming soon!',
        ttEngineOn: 'Audio engine ready',
        ttEngineOff: 'Audio engine not ready',
        ttLanguage: 'Interface language',
        ttProjectName: 'Project name',
        ttNewProject: 'New project (choose template)',
        ttOpenProject: 'Open project (.ibom)',
        ttSaveProject: 'Save project as .ibom file',
        ttExportWav: 'Export mixdown as WAV (offline render from start of timeline)',
        ttGoToStart: 'Go to start (reset time to beginning)',
        ttPause: 'Pause playback',
        ttStopTransport: 'Stop playback',
        ttRecord: 'Record',
        ttTimeCode: 'Playhead position (bar:beat:subdivision)',
        ttBpm: 'Tempo (beats per minute)',
        ttLoopActive: 'Loop on — repeats playback within ruler selection',
        ttLoopPrompt: 'Loop off — click to repeat playback within ruler selection',
        ttLoopNoRegion: 'Drag on the ruler to select a loop range first',
        ttAutomationLanes: 'Show track automation lanes',
        ttMasterVolume: 'Master output level',
        ttZoom: 'Timeline horizontal zoom (pixels per beat)',
        ttGridDivision: 'Grid snap / subdivision',
        ttSelectTool: 'Select tool: move and trim clips',
        ttFadeTool: 'Fade tool: drag clip edges for fade in/out',
        ttCloseMixer: 'Close mixer panel',
        ttMixerResize: 'Drag to resize mixer height',
        ttPianoRollClose: 'Close piano roll',
        vocalPresets: 'Vocal Presets',
        vocalPresetHint: 'Applies to the selected track’s insert FX chain — knobs stay fully editable.',
        vocalPresetClean: 'Clean Vocal',
        vocalPresetPop: 'Pop Vocal',
        vocalPresetRap: 'Rap Vocal',
        vocalPresetWarm: 'Warm Vocal',
        vocalPresetRadio: 'Radio Voice',
        lyrics: 'Lyrics',
        lyricsRowHint: 'Click empty space to add a lyric line at that time',
        lyricsDragHint: 'Drag to move in time (handle beside the field, or empty area)',
        ttLyricsRow: 'Show or hide the lyrics row under the ruler',
        ttLyricsRowViewMode: 'View only: lyrics as plain text',
        ttLyricsRowEditMode: 'Edit: add, move, and delete lyric lines',
    }
}; 